<template>
    <v-container class="pa-0 context-drop">
        <v-row no-gutters class="mb-1" v-if="dropDetails.units !== null">
            <v-col cols="1">
                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                        <package-icon v-on="on" :class="[$vuetify.breakpoint.xlOnly ? 'icon-xl' : 'icon-lg-down', 'wrld_black--text']" color="#777777" class="custom-class"></package-icon>
                    </template>
                    <span>{{$t('shipments.units')}}</span>
                </v-tooltip>
            </v-col>
            <v-col cols="11" class="drop-text">
                <span
                  class="wrld_black--text"
                >{{dropDetails.units + ' ' + units}}</span>
            </v-col>
        </v-row>
        <template
          v-if="hasUtilization"
        >
          <v-row no-gutters class="mb-1" v-if="dropDetails.weight !== null">
              <v-col cols="1">
                  <v-tooltip left>
                      <template v-slot:activator="{ on }">
                          <underline-icon v-on="on" :class="[$vuetify.breakpoint.xlOnly ? 'icon-xl' : 'icon-lg-down', 'wrld_black--text']" class="custom-class"></underline-icon>
                      </template>
                      <span>{{$t('shipments.weight_second')}}</span>
                  </v-tooltip>
              </v-col>
              <v-col v-if="dropDetails.vehicle != '' &&  dropDetails.vehicle.vehicleLimits" cols="11" class="drop-text wrld_black--text">
                  <span>{{dropDetails.weight | roundValueWeight(0)}} kg / <span :style="`color:${utilizationWeightColorDimensions};`">{{dropDetails.weight | utilizationWeight(dropDetails.vehicle.vehicleLimits.maxWeight, 0)}}%</span></span>
              </v-col>
              <v-col v-else-if="dropDetails.vehicle.maxWeight != null" cols="11" class="drop-text wrld_black--text">
                  <span>{{dropDetails.weight | roundValueWeight(0)}} kg / <span :style="`color:${utilizationWeightColor};`">{{dropDetails.weight | utilizationWeight(dropDetails.vehicle.maxWeight, 0)}}%</span></span>
              </v-col>
              <v-col v-else-if="dropDetails.vehicle === '' || !dropDetails.vehicle.vehicleLimits" cols="11" class="drop-text wrld_black--text">
                  <span>{{dropDetails.weight | roundValueWeight(0)}} kg</span>
              </v-col>
          </v-row>

          <v-row no-gutters class="mb-1" v-if="dropDetails.volume !== null">
              <v-col cols="1">
                  <v-tooltip left>
                      <template v-slot:activator="{ on }">
                          <move-icon v-on="on" :class="[$vuetify.breakpoint.xlOnly ? 'icon-xl' : 'icon-lg-down', 'wrld_black--text']" class="custom-class"></move-icon>
                      </template>
                      <span>{{$t('shipments.volume_second')}}</span>
                  </v-tooltip>
              </v-col>
              <v-col cols="11" class="drop-text">
                  <span
                      v-if="dropDetails.vehicle != '' && dropDetails.vehicle.vehicleLimits"
                      class="wrld_black--text"
                  >{{dropDetails.volume | roundValue(1)}} m&sup3; / <span :style="`color:${utilizationVolumeColorDimensions};`">{{dropDetails.volume | utilizationVolumeDimensions(dropDetails.vehicle.vehicleLimits.length, dropDetails.vehicle.vehicleLimits.height, dropDetails.vehicle.vehicleLimits.width , 0)}}%</span></span>
                  <span
                      v-else-if="dropDetails.vehicle.maxVolume != null"
                      class="wrld_black--text"
                  >{{dropDetails.volume | roundValue(1)}} m&sup3; / <span :style="`color:${utilizationVolumeColor};`">{{dropDetails.volume | utilizationVolume(dropDetails.vehicle.maxVolume, 0)}}%</span>
                  </span>
                  <span
                      v-else-if="dropDetails.vehicle === '' || !dropDetails.vehicle.vehicleLimits"
                      class="wrld_black--text"
                  >{{dropDetails.volume | roundValue(1)}} m&sup3;</span>
              </v-col>
          </v-row>
        </template>
        <template
          v-else
        >
        <v-row no-gutters class="mb-1" v-if="dropDetails.weight !== null">
              <v-col cols="1">
                  <v-tooltip left>
                      <template v-slot:activator="{ on }">
                          <underline-icon v-on="on" :class="[$vuetify.breakpoint.xlOnly ? 'icon-xl' : 'icon-lg-down', 'wrld_black--text']" class="custom-class"></underline-icon>
                      </template>
                      <span>{{$t('shipments.weight_second')}}</span>
                  </v-tooltip>
              </v-col>
              <v-col cols="11" class="drop-text wrld_black--text">
                  <span>{{dropDetails.weight | roundValueWeight(0)}} kg</span>
              </v-col>
          </v-row>

          <v-row no-gutters class="mb-1" v-if="dropDetails.volume !== null">
              <v-col cols="1">
                  <v-tooltip left>
                      <template v-slot:activator="{ on }">
                          <move-icon v-on="on" :class="[$vuetify.breakpoint.xlOnly ? 'icon-xl' : 'icon-lg-down', 'wrld_black--text']" class="custom-class"></move-icon>
                      </template>
                      <span>{{$t('shipments.volume_second')}}</span>
                  </v-tooltip>
              </v-col>
              <v-col cols="11" class="drop-text">
                  <span
                      class="wrld_black--text"
                  >{{dropDetails.volume | roundValue(1)}} m&sup3;</span>
              </v-col>
          </v-row>
        </template>
    </v-container>
</template>

<script>
  export default {
    name: 'ShipmentsGroupByDayContextDrop',
    components: {},
    props: {
      dropDetails: Object
    },
    computed: {
        units () {
            if (this.dropDetails.units === 1) {
                return this.$i18n.t('shipments.unit_lower_case')
            } else if (this.dropDetails.units >= 2 && this.dropDetails.units <= 4) {
                return this.$i18n.t('shipments.units_lower_case')
            } else if (this.dropDetails.units >= 5) {
                return this.$i18n.t('shipments.units_lower_case_two')
            }
        },
        utilizationWeightColorDimensions () {
            if (this.$options.filters.utilizationWeight(this.dropDetails.weight, this.dropDetails.vehicle.vehicleLimits.maxWeight, 0) >= 0
            && this.$options.filters.utilizationWeight(this.dropDetails.weight, this.dropDetails.vehicle.vehicleLimits.maxWeight, 0) <= 50) {
                return 'var(--v-wrld_green-base);'
            } else if (this.$options.filters.utilizationWeight(this.dropDetails.weight, this.dropDetails.vehicle.vehicleLimits.maxWeight, 0) >= 51
            && this.$options.filters.utilizationWeight(this.dropDetails.weight, this.dropDetails.vehicle.vehicleLimits.maxWeight, 0) <= 79) {
                return 'var(--v-wrld_yellow_orange-base);'
            } else if (this.$options.filters.utilizationWeight(this.dropDetails.weight, this.dropDetails.vehicle.vehicleLimits.maxWeight, 0) >= 80) {
                return 'var(--v-alert_red-base);'
            }
        },
    utilizationVolumeColorDimensions () {
      if (this.$options.filters.utilizationVolumeDimensions(this.dropDetails.volume, this.dropDetails.vehicle.vehicleLimits.length, this.dropDetails.vehicle.vehicleLimits.height, this.dropDetails.vehicle.vehicleLimits.width , 0) >= 0
          && this.$options.filters.utilizationVolumeDimensions(this.dropDetails.volume, this.dropDetails.vehicle.vehicleLimits.length, this.dropDetails.vehicle.vehicleLimits.height, this.dropDetails.vehicle.vehicleLimits.width , 0) <= 50) {
        return 'var(--v-wrld_green-base);'
        } else if (this.$options.filters.utilizationVolumeDimensions(this.dropDetails.volume, this.dropDetails.vehicle.vehicleLimits.length, this.dropDetails.vehicle.vehicleLimits.height, this.dropDetails.vehicle.vehicleLimits.width , 0) >= 51
            && this.$options.filters.utilizationVolumeDimensions(this.dropDetails.volume, this.dropDetails.vehicle.vehicleLimits.length, this.dropDetails.vehicle.vehicleLimits.height, this.dropDetails.vehicle.vehicleLimits.width , 0) <= 79) {
          return 'var(--v-wrld_yellow_orange-base);'
        } else if (this.$options.filters.utilizationVolumeDimensions(this.dropDetails.volume, this.dropDetails.vehicle.vehicleLimits.length, this.dropDetails.vehicle.vehicleLimits.height, this.dropDetails.vehicle.vehicleLimits.width , 0) >= 80) {
          return 'var(--v-alert_red-base);'
        }
      },
      utilizationWeightColor () {
      if (this.$options.filters.utilizationWeight(this.dropDetails.weight, this.dropDetails.vehicle.maxWeight, 0) >= 0
          && this.$options.filters.utilizationWeight(this.dropDetails.weight, this.dropDetails.vehicle.maxWeight, 0) <= 50) {
        return 'var(--v-wrld_green-base);'
      } else if (this.$options.filters.utilizationWeight(this.dropDetails.weight, this.dropDetails.vehicle.maxWeight, 0) >= 51
          && this.$options.filters.utilizationWeight(this.dropDetails.weight, this.dropDetails.vehicle.maxWeight, 0) <= 79) {
        return 'var(--v-wrld_yellow_orange-base);'
      } else if (this.$options.filters.utilizationWeight(this.dropDetails.weight, this.dropDetails.vehicle.maxWeight, 0) >= 80) {
        return 'var(--v-alert_red-base);'
      }
    },
    utilizationVolumeColor () {
      if (this.$options.filters.utilizationVolume(this.dropDetails.volume, this.dropDetails.vehicle.maxVolume, 0) >= 0
          && this.$options.filters.utilizationVolume(this.dropDetails.volume, this.dropDetails.vehicle.maxVolume, 0) <= 50) {
        return 'var(--v-wrld_green-base);'
      } else if (this.$options.filters.utilizationVolume(this.dropDetails.volume, this.dropDetails.vehicle.maxVolume, 0) >= 51
          && this.$options.filters.utilizationVolume(this.dropDetails.volume, this.dropDetails.vehicle.maxVolume, 0) <= 79) {
        return 'var(--v-wrld_yellow_orange-base);'
      } else if (this.$options.filters.utilizationVolume(this.dropDetails.volume, this.dropDetails.vehicle.maxVolume, 0) >= 80) {
        return 'var(--v-alert_red-base);'
      }
    },
    hasUtilization () {
      switch (this.dropDetails.type) {
        case 'OnePL':
        case 'TwoPL':
          return true
        default:
          return false
      }
    }
    },
    methods: {}
  }
</script>

<style lang="scss" scoped>
.context-drop {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 13px;
    margin-top: 40px;
}
.drop-text {
    margin-top: -1px;
}
.icon-xl {
    width: 17px;
    height: 17px;
}
.icon-lg-down {
    width: 15px;
    height: 15px;
}
</style>
